import { useParams } from "react-router-dom";
import { authService } from "../../../services";
import ProfileWrapper from "./ProfileWrapper";
import PublicProfilePageV2 from "./PublicProfilePageV2";

function ProfilePageWrapper() {
  const { username } = useParams();




  if (authService.isAuthenticated() && username) {
    return <ProfileWrapper username={username} />;
  } else {
    return <PublicProfilePageV2 />;
  }
}

export default ProfilePageWrapper;
